"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 29 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var PriceZoneConverter_1 = require("./conversions/PriceZoneConverter");

var PriceZoneConverterImpl_1 = require("./conversions/PriceZoneConverterImpl");
/**
 * Configures price zone app module.
 *
 * @author JMe
 */


var PriceZoneAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(PriceZoneAppModule, _AppModule_1$AppModul);

  function PriceZoneAppModule() {
    var _this;

    _classCallCheck(this, PriceZoneAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'priceZoneAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceZoneAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(PriceZoneConverter_1.PriceZoneConverter).to(PriceZoneConverterImpl_1.PriceZoneConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return PriceZoneAppModule;
}(AppModule_1.AppModule);

exports.PriceZoneAppModule = PriceZoneAppModule;